var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.VI=require("moment");module.exports=$CLJS.VI;